import React from "react";

const MarketOrderDocs = (
    <>
        <p>
            place a market order once the setup has been achieved.
        </p>
        params:
        <p>
            <b>QuantityBasisValue:</b> the amount you'd like to invest based on the QuantityBasis (dollars,
            quantity) that you chose. So if you would like to make an investment of max
            1000$, the quantity basis would be dollars, and the quantityBasisValue would
            be 1000$. Similarly, if QuantityBasis of Quantity was chosen, and you'd like
            to buy 5 contracts/shares, this param would be set to 5.
        </p>
    </>
);

export default MarketOrderDocs;
